module.exports = __webpack_public_path__ + "img/speedup_process.ceaa2978.jpg";